import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Sparkles } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";

export default function NewArrivals() {
  const [items, setItems] = useState([]);
  useSEO({
    title: "New Arrivals · Fresh Drop",
    description: "This week's freshest arrivals at Venvay — new tees, oversized fits, hoodies and prints. Limited runs, first come first served.",
    keywords: "new arrivals venvay, new t-shirt drop india, fresh streetwear india, weekly clothing drop",
    canonicalPath: "/new",
  });

  useEffect(() => {
    api.get("/products").then((r) => {
      // items tagged 'new' first, then most recent by created_at
      const list = [...r.data].sort((a, b) => {
        const an = (a.tags || []).includes("new") ? 1 : 0;
        const bn = (b.tags || []).includes("new") ? 1 : 0;
        if (an !== bn) return bn - an;
        return (b.created_at || "").localeCompare(a.created_at || "");
      });
      setItems(list.slice(0, 12));
    });
  }, []);

  return (
    <div>
      <div className="relative bg-[#0F0B08] text-[#F0E5D0] overflow-hidden border-b border-[#D4B25C]/10">
        <div className="max-w-7xl mx-auto px-6 py-20 relative">
          <p className="label-tag text-[#D4B25C]/60 mb-4">Fresh Drop · Feb 2026</p>
          <h1 className="font-display text-6xl sm:text-7xl lg:text-8xl font-black leading-none">
            NEW<br />
            <span className="text-[#D4B25C]">ARRIVALS.</span>
          </h1>
          <p className="mt-6 text-white/70 max-w-md">
            Just in — this week's freshest tees, hoodies and print-ready silhouettes. Limited runs, first come first served.
          </p>
          <div className="mt-8 inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase font-semibold text-[#D4B25C]">
            <Sparkles size={14} /> Refreshed weekly
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        {items.length === 0 ? (
          <p className="text-center text-muted-foreground py-20">Loading fresh picks…</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {items.map((p) => <ProductCard key={p.id} p={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
